import * as go from 'gojs';

export const ungroupSelection = (diagram: go.Diagram, parts: go.Set<go.Part>) => {
  const nodes = new go.List<go.Node>();
  const groups = new go.List<go.Group>();
  parts.each((group) => {
    if (!(group instanceof go.Group)) {
      return;
    }

    groups.push(group);
    nodes.addAll(group.memberParts.filter((m) => m instanceof go.Node) as go.Iterator<go.Node>);
  });

  parts.each((node) => {
    if (!(node instanceof go.Node) || !node.containingGroup) {
      return;
    }

    groups.push(node.containingGroup);
    nodes.add(node);
  });

  diagram.commit(() => {
    diagram.commandHandler.addTopLevelParts(nodes);
    groups
      .filter((p) => p.memberParts.filter((mp) => mp instanceof go.Node).count < 2)
      .each((group) => {
        diagram.commandHandler.addTopLevelParts(group.memberParts);
        diagram.model.removeNodeData(group.data);
      });
  });
};
